// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fiRThO4PsRmQkXaowIPQ {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  padding: 14px;
  gap: 10px;
}

.Oavh4uPugkEZ8vfRLsGG {
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--surface-bg);
  padding: 12px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.SCZgGEQOfZ3Baw7lj2kV h1 {
  margin: 0;
  font-size: 22px;
  color: var(--accent-color);
}

.SCZgGEQOfZ3Baw7lj2kV p {
  margin-top: 5px;
  color: var(--text-muted);
  font-size: 13px;
}

.QyL8nZMQu4e5FzpCVdXg {
  padding: 6px 12px;
  border-radius: 6px;
  background: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-muted);
}

.fcmOFFMyGVeFihEL1c05 {
  display: flex;
  gap: 8px;
}

.tJVTMwfBNAqekRb69Pwl {
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--surface-bg);
  color: var(--text-muted);
  cursor: pointer;
}

.tJVTMwfBNAqekRb69Pwl.LgPS_xr9xAYf9rCpbufT {
  color: var(--accent-color);
  border-color: var(--accent-color);
  background: var(--surface-bg-2);
}

.qm3E8tJ4DozRmWAyWKT8 {
  min-height: 0;
  flex: 1;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--surface-bg);
  overflow: hidden;
  padding: 10px;
}

.TFEoieYYx65bsE6veyZc { display: flex; align-items: center; }
.zeKfT0JYZOhczZUV8Koa { margin-right: 8px; color: var(--text-muted); font-size: 12px; }

.bIEIydvw42MYySravHHv {
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid var(--border-color);
  color: var(--text-color);
  background: var(--surface-bg-2);
}

.v5KJuL6MIGH9uiDL5lzM {
  font-family: Consolas, monospace;
  font-size: 11px;
  color: var(--text-color);
}

.KuAembzPL6hNLRb9Zsos { font-size: 12px; word-break: break-all; color: var(--text-muted); }

.Bu3zv9Uo42uoXT6yACi_ {
  padding: 4px 8px;
  background: transparent;
  color: var(--text-muted);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  font-size: 11px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .fiRThO4PsRmQkXaowIPQ { padding: 8px; gap: 8px; }
  .Oavh4uPugkEZ8vfRLsGG { padding: 10px; align-items: flex-start; gap: 8px; }
  .SCZgGEQOfZ3Baw7lj2kV h1 { font-size: 18px; }
  .SCZgGEQOfZ3Baw7lj2kV p { font-size: 11px; }
  .QyL8nZMQu4e5FzpCVdXg { font-size: 11px; }
  .fcmOFFMyGVeFihEL1c05 { overflow-x: auto; white-space: nowrap; }
  .tJVTMwfBNAqekRb69Pwl { padding: 7px 10px; font-size: 12px; }
  .qm3E8tJ4DozRmWAyWKT8 { padding: 6px; }
}
`, "",{"version":3,"sources":["webpack://./components/AdminDashboard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,OAAO;EACP,qCAAqC;EACrC,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;AACf;;AAEA,wBAAe,aAAa,EAAE,mBAAmB,EAAE;AACnD,wBAAoB,iBAAiB,EAAE,wBAAwB,EAAE,eAAe,EAAE;;AAElF;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,wBAAwB;AAC1B;;AAEA,wBAAa,eAAe,EAAE,qBAAqB,EAAE,wBAAwB,EAAE;;AAE/E;EACE,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wBAAQ,YAAY,EAAE,QAAQ,EAAE;EAChC,wBAAU,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE;EAC5D,2BAAiB,eAAe,EAAE;EAClC,0BAAgB,eAAe,EAAE;EACjC,wBAAW,eAAe,EAAE;EAC5B,wBAAU,gBAAgB,EAAE,mBAAmB,EAAE;EACjD,wBAAU,iBAAiB,EAAE,eAAe,EAAE;EAC9C,wBAAW,YAAY,EAAE;AAC3B","sourcesContent":[".page {\r\n  height: 100vh;\r\n  width: 100vw;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 14px;\r\n  gap: 10px;\r\n}\r\n\r\n.header {\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  background: var(--surface-bg);\r\n  padding: 12px 14px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.leftHeader h1 {\r\n  margin: 0;\r\n  font-size: 22px;\r\n  color: var(--accent-color);\r\n}\r\n\r\n.leftHeader p {\r\n  margin-top: 5px;\r\n  color: var(--text-muted);\r\n  font-size: 13px;\r\n}\r\n\r\n.backBtn {\r\n  padding: 6px 12px;\r\n  border-radius: 6px;\r\n  background: transparent;\r\n  border: 1px solid var(--border-color);\r\n  color: var(--text-muted);\r\n}\r\n\r\n.tabBar {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.tabBtn {\r\n  padding: 8px 14px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border-color);\r\n  background: var(--surface-bg);\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n}\r\n\r\n.tabBtn.active {\r\n  color: var(--accent-color);\r\n  border-color: var(--accent-color);\r\n  background: var(--surface-bg-2);\r\n}\r\n\r\n.content {\r\n  min-height: 0;\r\n  flex: 1;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  background: var(--surface-bg);\r\n  overflow: hidden;\r\n  padding: 10px;\r\n}\r\n\r\n.stageFilter { display: flex; align-items: center; }\r\n.stageFilterLabel { margin-right: 8px; color: var(--text-muted); font-size: 12px; }\r\n\r\n.stageSelect {\r\n  padding: 6px 10px;\r\n  border-radius: 6px;\r\n  border: 1px solid var(--border-color);\r\n  color: var(--text-color);\r\n  background: var(--surface-bg-2);\r\n}\r\n\r\n.monoCell {\r\n  font-family: Consolas, monospace;\r\n  font-size: 11px;\r\n  color: var(--text-color);\r\n}\r\n\r\n.emailCell { font-size: 12px; word-break: break-all; color: var(--text-muted); }\r\n\r\n.deleteButton {\r\n  padding: 4px 8px;\r\n  background: transparent;\r\n  color: var(--text-muted);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 6px;\r\n  font-size: 11px;\r\n  cursor: pointer;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .page { padding: 8px; gap: 8px; }\r\n  .header { padding: 10px; align-items: flex-start; gap: 8px; }\r\n  .leftHeader h1 { font-size: 18px; }\r\n  .leftHeader p { font-size: 11px; }\r\n  .backBtn { font-size: 11px; }\r\n  .tabBar { overflow-x: auto; white-space: nowrap; }\r\n  .tabBtn { padding: 7px 10px; font-size: 12px; }\r\n  .content { padding: 6px; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `fiRThO4PsRmQkXaowIPQ`,
	"header": `Oavh4uPugkEZ8vfRLsGG`,
	"leftHeader": `SCZgGEQOfZ3Baw7lj2kV`,
	"backBtn": `QyL8nZMQu4e5FzpCVdXg`,
	"tabBar": `fcmOFFMyGVeFihEL1c05`,
	"tabBtn": `tJVTMwfBNAqekRb69Pwl`,
	"active": `LgPS_xr9xAYf9rCpbufT`,
	"content": `qm3E8tJ4DozRmWAyWKT8`,
	"stageFilter": `TFEoieYYx65bsE6veyZc`,
	"stageFilterLabel": `zeKfT0JYZOhczZUV8Koa`,
	"stageSelect": `bIEIydvw42MYySravHHv`,
	"monoCell": `v5KJuL6MIGH9uiDL5lzM`,
	"emailCell": `KuAembzPL6hNLRb9Zsos`,
	"deleteButton": `Bu3zv9Uo42uoXT6yACi_`
};
export default ___CSS_LOADER_EXPORT___;
